import PromptWriter from "./PromptWriter";

const AdditionalAssignmentProperties = ({
  properties,
  onToggle,
  onPropertyUpdate,
}) => {
  const defaultAdditionalProperties = {
    links: {
      patient_satisfaction_survey: { url: "" },
      click_to_call: { url: "" },
    },
    text_inactivity_timeout_minutes: 5,
  };

  return (
    <div>
      <div>
        {Object.entries(defaultAdditionalProperties).map(([key, prop]) => {
          const isSelected = Object.keys(properties).includes(key);
          return (
            <label
              key={key}
              className="flex items-center px-3 py-2 text-gray-200 hover:bg-[#1e3a6a] cursor-pointer"
            >
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => onToggle({ key, prop })}
                className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-sm">{key}</span>
            </label>
          );
        })}

        {Object.keys(properties).length > 0 && (
          <div className="card-glass mt-1 flex flex-col p-1 h-64 overflow-x-scroll">
            <PromptWriter
              value={JSON.stringify(properties, null, 2)}
              onChange={(e) => {
                onPropertyUpdate(e);
              }}
              language="json"
              readOnly={false}
              wordwrap="off"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdditionalAssignmentProperties;
